import React from 'react';
import { Checkbox } from 'antd';
import PropTypes from 'prop-types';

export const SOSSingleCheckBox = ({ handleChange, defaultValue }) => (
  <Checkbox
    className="sos-checkbox"
    defaultValue={defaultValue}
    onChange={handleChange}
  ></Checkbox>
);

SOSSingleCheckBox.propTypes = {
  handleChange: PropTypes.func,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.array,
};
